import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "list" }
const _hoisted_2 = { class: "no-bullets" }
const _hoisted_3 = { class: "target-info" }
const _hoisted_4 = { class: "target-name" }
const _hoisted_5 = {
  key: 0,
  class: "target-nickname"
}

import { ref,watch,onMounted,computed,provide, reactive } from "vue";
import { TelegramClient } from "@/websocket/Client";
import { useStore } from 'vuex';
import { EditOutlined } from "@ant-design/icons-vue";
import EditNameModal from "./EditNameModal.vue";
interface Session {
    id: number;
    user: {
      name: string;
      imgId: number;
    };
    messages: any[]; // 可以定义 MessageItem 类型
  }
  

  // 过滤后的会话列表 (计算属性)
  interface UserInfo {
	   userId:number;	// 用户ID 聊天唯一ID
     phone:string;	// 手机号
     userName:string;	// 用户名
     userNick:string;	// 用户昵称
     isContact:boolean;	// 是否为联系人
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FriendListModal',
  props: {
    visible: { type: Boolean }
  },
  emits: ["update:visible", "success"],
  setup(__props: any, { emit: __emit }) {

const editNameModalVisible = ref(false);
const client = TelegramClient.getInstance();
const store = useStore();
  // 定义接口 (类型)
  const sessions = computed<Session[]>(() => {
    const filterKey = store.state.filterKey;
    return store.state.sessions.filter((session: Session) =>
      session.user.name.includes(filterKey)
    );
  });


  const curSelectUser = ref<UserInfo>();
provide('curSelectUser', curSelectUser); // 提供数据


const targetIdsList = ref<UserInfo[]>([]);



const props = __props;

const emit = __emit;

 
const refreshFriendList = ()=>{
  handleGetContacts();
  console.log("refreshFriendList");
}


// 发送验证码
const handleSendCode = async () => {
 
};

onMounted(() => {
   

});


const showEditNameModal = (target: any) => {
   console.log("showEditNameModal");
   curSelectUser.value = target;
   var tt = target.userId;
   editNameModalVisible.value = true;

};


const handleCancel = () => {
  console.log("handleCancel");
  emit("update:visible", false);
};


const handleOkFriend = () => {
  emit("update:visible", false);
};

 
const handleGetContacts = async ()=>
{
    const account = localStorage.getItem("username") || "";
    var name = store.state.user.name;
    const result = await client.sendGetTelegramContacts(
      account,
      name
    );
    if(result.message && result.message.list)
    {
      targetIdsList.value = result.message.list;
    }
    console.log("handleGetContacts");
}


// 监听可见性变化
watch(
  () => props.visible,
  (newVisible) => {
    if (newVisible) {
      handleGetContacts();
       
    }
  }
);

 
 

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      title: "好友列表",
      onCancel: handleCancel,
      onOk: handleOkFriend,
      width: "500px",
      okText: "确定",
      cancelText: "取消"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("ul", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(targetIdsList.value, (target) => {
              return (_openBlock(), _createElementBlock("li", null, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("span", _hoisted_4, _toDisplayString(target.userName), 1),
                  (target.userNick)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, " (" + _toDisplayString(target.userNick) + ") ", 1))
                    : _createCommentVNode("", true),
                  _createVNode(_component_a_button, {
                    type: "link",
                    onClick: ($event: any) => (showEditNameModal(target))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(EditOutlined)),
                      _cache[1] || (_cache[1] = _createTextVNode("编辑联系人 "))
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ])
              ]))
            }), 256))
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(EditNameModal, {
      visible: editNameModalVisible.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((editNameModalVisible).value = $event)),
      onRefreshFriendList: refreshFriendList
    }, null, 8, ["visible"])
  ], 64))
}
}

})